import React from "react";
import { ShieldCheck } from "lucide-react";

/** Small verified badge — shows next to a name/profile if user is verified. */
export default function VerifiedBadge({ verified, size = "sm", className = "" }) {
    if (!verified) return null;
    const sizes = {
        xs: "h-3.5 w-3.5",
        sm: "h-4 w-4",
        md: "h-5 w-5",
    };
    return (
        <span
            title="Verified profile"
            data-testid="verified-badge"
            className={`inline-flex items-center justify-center text-primary flex-shrink-0 ${className}`}
        >
            <ShieldCheck className={sizes[size] || sizes.sm} strokeWidth={2.8} fill="currentColor" />
        </span>
    );
}
